export default __webpack_public_path__ + "static/g2two-d1bfd42f81236498c6e0baf0a25e9ac1.jpg";